/* libs */
import React, { Component } from "react";
import PropTypes from "prop-types";

/* components */
import withForm from "../../../shared/Form";
import { TextInput, SelectInput, CheckBox } from "../../../shared/Forms";
import Pages from "./Pages";

/* helpers */
class Form extends Component {
	render() {
		const { themes, pages, formApi, values } = this.props;
		const navigationTypes = [
			{
				key: "sideMenu",
				value: "sideMenu",
				label: "Side Menu",
			},
			{
				key: "tabBar",
				value: "tabBar",
				label: "Tab Bar",
			},
			{
				key: "twoColumnGrid",
				value: "twoColumnGrid",
				label: "Two Column Grid",
			},
			{
				key: "threeColumnGrid",
				value: "threeColumnGrid",
				label: "Three Column Grid",
			},
			{
				key: "fullScreen",
				value: "fullScreen",
				label: "Full Screen",
			},
		];
		let themeChoices = [];
		if (themes && themes.length > 0) {
			themeChoices = themes.map(theme => ({
				key: theme.id,
				value: theme.id,
				label: theme.name,
			}));
		}

		return (
			<div className="row">
				<div className="col-md-4">
					<TextInput field="title" id="title" placeholder="title" />
					{themes && themes.length > 0 && (
						<SelectInput values={themeChoices} field="themeId" id="themeId" placeholder="theme" />
					)}
					<SelectInput
						values={navigationTypes}
						initialValue={values.kind || "sideMenu"}
						field="kind"
						id="kind"
						placeholder="Navigation type"
					/>
					<TextInput field="switchText" id="switchText" placeholder="Label To Switch Experience" />
					{values.kind === "tabBar" && (
						<React.Fragment>
							<TextInput field="moreText" id="moreText" placeholder="More Label" />
							<CheckBox field="hideTitles" id="hideTitles" label="Hide Tab Labels" />
						</React.Fragment>
					)}
				</div>
				<div className="col-md-8">
					{pages && pages.length > 0 && <Pages values={values} formApi={formApi} pages={pages} />}
					{pages && pages.length === 0 && <p>Please add a page to the experience first</p>}
				</div>
				<div className="btn btn-success" onClick={() => this.props.submitForm(true)}>
					Save Navigation
				</div>
			</div>
		);
	}
}

Form.propTypes = {
	values: PropTypes.object,
	formApi: PropTypes.object,
	themes: PropTypes.array,
	pages: PropTypes.array,
	submitForm: PropTypes.array,
};

export default withForm(Form);
